var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _polygon, _polygon2, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuideMaterial6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 567.18 394.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}.cls-2{fill:#f04e23;}.cls-3{fill:#812990;}.cls-4{fill:#fff;}.cls-5,.cls-6{fill:none;stroke-miterlimit:10;stroke-width:0.25px;}.cls-5{stroke:#fbb040;}.cls-6{stroke:#6b7b84;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.49,394l.3-.35a2.2,2.2,0,0,0,1.67.78c1.09,0,1.4-.61,1.4-1.06,0-1.57-3.2-.76-3.2-2.62,0-.87.78-1.42,1.75-1.42a2.31,2.31,0,0,1,1.81.75l-.3.34a1.91,1.91,0,0,0-1.53-.68c-.71,0-1.25.41-1.25,1,0,1.36,3.2.61,3.2,2.6,0,.69-.46,1.51-1.9,1.51A2.5,2.5,0,0,1,.49,394Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.31,390A.32.32,0,0,1,6,390a.32.32,0,1,1-.64,0Zm.11,4.79v-3.86h.42v3.86Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.93,394.75v-.35l2.29-3.15H6.93v-.36H9.76v.33l-2.32,3.16H9.79v.37Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.67,392.81a1.91,1.91,0,0,1,1.85-2,1.85,1.85,0,0,1,1.83,2V393H11.12a1.5,1.5,0,0,0,1.51,1.53,1.69,1.69,0,0,0,1.26-.53l.22.27a2,2,0,0,1-1.51.62A1.9,1.9,0,0,1,10.67,392.81Zm1.85-1.66a1.45,1.45,0,0,0-1.4,1.47h2.8A1.41,1.41,0,0,0,12.52,391.15Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.29,391.18a.36.36,0,0,1,.36-.35.35.35,0,0,1,0,.7A.36.36,0,0,1,15.29,391.18Zm0,3.29a.35.35,0,0,1,.36-.34.35.35,0,0,1,.35.34.35.35,0,0,1-.35.35A.36.36,0,0,1,15.29,394.47Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.84,394l.31-.27a1.77,1.77,0,0,0,1.49.74c.83,0,1.35-.43,1.35-1.14s-.63-1.08-1.43-1.08h-.5v-.43h.5c.71,0,1.35-.31,1.35-1s-.59-1-1.28-1a1.79,1.79,0,0,0-1.43.68l-.29-.29a2.22,2.22,0,0,1,1.74-.8c.93,0,1.72.5,1.72,1.4A1.29,1.29,0,0,1,21.23,392a1.36,1.36,0,0,1,1.22,1.33c0,.88-.66,1.52-1.8,1.52A2.1,2.1,0,0,1,18.84,394Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.4,392.09c0-1.28.53-2.75,2-2.75s2,1.47,2,2.75-.55,2.75-2,2.75S23.4,393.35,23.4,392.09Zm3.45,0c0-1.11-.36-2.34-1.48-2.34s-1.49,1.23-1.49,2.34.36,2.34,1.49,2.34S26.85,393.18,26.85,392.09Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.23,392.81a1.88,1.88,0,0,1,1.87-2,1.59,1.59,0,0,1,1.37.66l-.29.25a1.23,1.23,0,0,0-1.06-.53,1.66,1.66,0,0,0,0,3.3,1.22,1.22,0,0,0,1.06-.55l.29.26a1.59,1.59,0,0,1-1.37.66A1.88,1.88,0,0,1,28.23,392.81Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37,394.75v-2.7c0-.55-.23-.88-.77-.88a1.44,1.44,0,0,0-1.11.65v2.93h-.42v-2.7c0-.55-.22-.88-.77-.88a1.49,1.49,0,0,0-1.11.66v2.92H32.4v-3.86h.41v.58a1.7,1.7,0,0,1,1.25-.68,1,1,0,0,1,1,.73,1.62,1.62,0,0,1,1.28-.73c.72,0,1.06.4,1.06,1.18v2.78Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.33,394.75l-1.28-1.7-1.29,1.7h-.49l1.53-2-1.44-1.88h.49l1.2,1.59,1.19-1.59h.5l-1.44,1.88,1.53,2Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.41,394.75v-.38c1.82-1.46,3-2.5,3-3.53a1.1,1.1,0,0,0-1.21-1.09,1.75,1.75,0,0,0-1.47.7l-.31-.29a2.18,2.18,0,0,1,1.78-.82,1.53,1.53,0,0,1,1.68,1.5c0,1.17-1.24,2.25-2.79,3.49h2.81v.42Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.08,392.09c0-1.28.54-2.75,2-2.75s2,1.47,2,2.75-.55,2.75-2,2.75S49.08,393.35,49.08,392.09Zm3.46,0c0-1.11-.36-2.34-1.48-2.34s-1.5,1.23-1.5,2.34.37,2.34,1.5,2.34S52.54,393.18,52.54,392.09Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.92,392.81a1.88,1.88,0,0,1,1.87-2,1.56,1.56,0,0,1,1.36.66l-.28.25a1.24,1.24,0,0,0-1.06-.53,1.66,1.66,0,0,0,0,3.3,1.23,1.23,0,0,0,1.06-.55l.28.26a1.56,1.56,0,0,1-1.36.66A1.88,1.88,0,0,1,53.92,392.81Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.68,394.75v-2.7c0-.55-.23-.88-.78-.88a1.44,1.44,0,0,0-1.1.65v2.93h-.42v-2.7c0-.55-.23-.88-.77-.88a1.47,1.47,0,0,0-1.11.66v2.92h-.42v-3.86h.42v.58a1.7,1.7,0,0,1,1.25-.68,1,1,0,0,1,1,.73,1.62,1.62,0,0,1,1.28-.73c.71,0,1.06.4,1.06,1.18v2.78Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "170.2 378.08 113.51 283.59 56.82 378.08 170.2 378.08"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0.13 0.13 56.82 0.13 170.2 189.1 56.82 378.08 0.13 378.08 0.13 0.13"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M58.14,207.47l-1.07.16c-.23,0-.39.13-.53.11-.41,0-.63-.51-1.2-.63-.14,0,0,0-.21-.07s.07,0-.28-.13c0,.38-.08.27-.08.56a2.18,2.18,0,0,0,.24,1c.1.21.15.14.14.44a2,2,0,0,0,.16,1.23,3.3,3.3,0,0,1,.43.86c.56,0,.48,0,.55.17.53,0,.19-.12.48-.17,0,0,.55.13.4-.55.41.11.22.32.48.3s.1-.2.14-.45-.11-.07.27-.25l-.08-.48c0-.56.13,0,.31.08l.24-1.69c0-.13.18-.07-.15-.55C58,207.44,58.22,207.45,58.14,207.47Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M58.29,206c-.06.22.13.13-.15.15l.32.72c.14-.07.09-.06.32-.07,0-.49,0-.32-.17-.56S58.51,206.09,58.29,206Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M54.29,205.4c-.08.32,0,0-.11.25s-.14.72.34.46C54.52,205.55,54.58,205.6,54.29,205.4Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M48.12,199.73a2.81,2.81,0,0,0-1,.15c-.59.15-.33.28-.14.56a3.52,3.52,0,0,0,1.39-.2c.26,0,.28,0,.13-.28h-.4Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M64.34,195.8a1.73,1.73,0,0,0-.08-.27l-.91-.34-1.94-.74c-.56-.23-1.31-.54-2-.9s-1.55-.78-2.36-1.29a5.39,5.39,0,0,1-1.95-2.2,6.92,6.92,0,0,1-.43-1.11h-.16a4.21,4.21,0,0,0-.88.12l-.83.21a10.26,10.26,0,0,1-2.23.42l-.29,0-.85,0a6.4,6.4,0,0,1-.64,0,13.31,13.31,0,0,1-1.34-.24l-.47-.1-.36.43a1.26,1.26,0,0,1,.24.22,1.61,1.61,0,0,1,.34,1.57,2.41,2.41,0,0,1-2.09,1.54c-.27,0-.52,0-.76,0h-.13a2.55,2.55,0,0,1-2.06-1.35,1.81,1.81,0,0,1,.14-2l.05-.07c.1-.16.21-.33.33-.49a6.1,6.1,0,0,0,.37-.59l.21-.42a2.76,2.76,0,0,1-2.31-1.75,5.68,5.68,0,0,1-.35-1.67l-.23.06-.37.09a2.89,2.89,0,0,1-.32.35,2,2,0,0,1-1.42.67,1.88,1.88,0,0,1-.57-.09h-.09a1.87,1.87,0,0,1-1.06-.33,1.27,1.27,0,0,1-.6-.42,1.37,1.37,0,0,1-.27-1.19,5.12,5.12,0,0,1,.91-2l.12-.16a1.83,1.83,0,0,1,.55-1.13c.24-.24.49-.45.73-.65l.2-.17c.11-.09.24-.21.4-.32a2.38,2.38,0,0,1,.38-1.06,4.52,4.52,0,0,1,1.32-1.29l.82-.47c.15-.09.28-.15.4-.23l.37-.22.22-.14a1.28,1.28,0,0,1,.63-.18,1.17,1.17,0,0,1,.52.12,1.25,1.25,0,0,1,.69,1.44l-.41,1.4A3.11,3.11,0,0,1,42.9,180a10.31,10.31,0,0,1,.86.59,6.06,6.06,0,0,1,.68.64H45l.19,0a4.51,4.51,0,0,0,1.26-.58l.18-.1a10.5,10.5,0,0,1,2.5-1.19,17.17,17.17,0,0,1,4.43-.63h.58c.82,0,1.64,0,2.41.08a13.37,13.37,0,0,1,1.83.25,10.79,10.79,0,0,1,4.43,1.92.81.81,0,0,0-.44-.61c-.23-.11-.11,0-.28-.14,0,0,0,0,0,0l-.18-.14c-.28-.18-.24.05-.34-.39l-.11.06,0,0c-.17.05-.11-.31-.28-.51s.07.15-.34-.06c-.22-.11,0,0-.13-.09a.38.38,0,0,0-.16-.09l-.15,0c-.66-.27-.54-.38-.54-1-.56-.15-.22-.58-.19-1,.07-.58-.28-.66-.14-1.29-.79,0-.47-.79-.69-1.63l0-.78c0-.16,0,.07.1-.22l-.22-.1c-.75-.45-.6-.8-.82-.94l-.55.17c-.17.12,0,.08-.25.14-.53-.49-.28-1.52-.46-2.18-.07-.28-.13-.67-.51-.76a1.25,1.25,0,0,1,.24-.49c-.19-.09-.28-.07-.47-.16a2.27,2.27,0,0,0-.25-1.28c-.15-.26-.05-.28-.4-.32-.09.38-.06.16-.4.32a2.21,2.21,0,0,1-.3,1.23s0,0,0,.05l-.07.09a1.59,1.59,0,0,0-.33.79h.24c0,.37,0,.15-.18.38s-.09,0-.05.4-.28.44-.24.89c0,.29.12.2.11.48s-.08.23-.07.46c0,.6.25.44,0,1s-.18,1.17-.54,1.77a9.47,9.47,0,0,0-.42.87,1.13,1.13,0,0,1-.9.35,3.38,3.38,0,0,1-.81-.4c-.16-.08-.28-.13-.35-.28s0-.1-.09-.23c-.19-.4-.72-.37-1.1-.51s-.51-.68-1.43-1l-.49-.16-.37-.25-.31-.34a4.17,4.17,0,0,0-.38-.27l-.34-.22c-.32-.17-.27,0-.28-.44.18-.06.38-.39.53-.6s0,0,.09-.14l.07-.18s0,0,0,0l.16-.4c-.33-.13,0,.06-.31-.09.12-.18.09-.08.16-.31.41-.2.31-.08.55,0,.49-.71.2-.26.31-.67s.33-.42.49-.68l-.29-.19c-.33-.18-.26.13-.26-.46a1.58,1.58,0,0,0-.65.48c-.08-.1-.08.17-.08-.23a1.34,1.34,0,0,1-.4.15c.24-.3.13,0,.25-.32a2.08,2.08,0,0,0-1.05.4c-.2-.14-.32-.13-.4-.4-.4,0-.11.06-.47.17a1.9,1.9,0,0,0-.65-.33V168c-.42,0-.71.27-1.07-.14,0,0-.18-.3-.21-.34-.3.08-.17.08-.4.23a.65.65,0,0,0-.36-.45c-.13-.08,0,0-.16,0l-.45,0c-.06,0,.12,0-.24.07v.25c.31.07,0,0,.23.09l.06,0,0,0c.24.11.26,0,.64,0a1.77,1.77,0,0,1,.15.73l-.59.2,0,0-.72.08c-.31,0-.2-.07-.32-.3l-.21.1-.2.12c-.24.18.12.07-.27.21a.74.74,0,0,1-.37,0c0,.21,0,.2-.18.46s0,.23-.38.27c0,.57.06.24.16.63l-.26.09c-.4.1-.21.1-.35.5s-.34.11-.51.85c.26.18.32.18.37.34a.77.77,0,0,1,0,.3c-.76-.06-.42,0-.7,0a3.14,3.14,0,0,0-.9-.14c0,.59,0,.19-.16.34l0,0-.12.19c0-.56.12-.17.16-.64-.68-.19-.65-.9-1.34-1s0-.16-.58-.17c-.15.29-.06.35-.32.55.08-.38,0-.12,0-.24-.3.07-.18.08-.4.24-.05-.37-.1-.31-.4-.16.06.24,0,.17.23.24a.94.94,0,0,0-.16.48l-.47-.4c-.22.41,0,.27-.31.49l-.11.06c-.1.06-.13.1-.23.17.12.43.21.08.08.4-.27,0-.29.11-.48.36l0,0a.14.14,0,0,1-.06.07.74.74,0,0,1-.13.12c-.11.11-.25.15-.29.4a.69.69,0,0,0,.2.46c-.18.21-.15.14-.16.48l-.36-.12c-.36-.08-.18.2-.28-.11h-.4c0,.54-.2.41-.08.64s.29.2.48.47c-.2.08-.07.06-.32,0,0,.42.1.14,0,.56-.25-.17-.12-.13-.4-.64s-.29-.18-.25-.72c-.33.1-.3.26-.47.48l-.39.41a1.41,1.41,0,0,0-.31.64c0,.23.14.36.14.79.05,0,0,0,0,0l.21,0c-.05.17,0,.09-.12.21a.5.5,0,0,1-.07.08c-.11.13,0,.05-.13.12l-.13.1,0,0-.1.07c-.2.16-.15.19-.24.4l0,.1c-.48,1.27-.78,1.27-2.2,1.81-.27.09,0,.06-.3.08s-.21-.19-.54,0-.06.19-.32.4-.46-.13-1.21.63a.66.66,0,0,1-.49.2c-.42,0-.11-.23-.64.12,0-.42.08-.15-.15-.25-.07.26-.06.21-.27.38-.49.36-.1-.11-.79.65l-.09.09-.24.3s-.05.07-.07.1c-.38.42-1.19.24-1.19,1.52h-.24a6.33,6.33,0,0,1-.08-.88,1.86,1.86,0,0,0-.57,1.43c.26.1.07-.13.21.2a1.1,1.1,0,0,1-.05,1,1.26,1.26,0,0,0-.16.43v.58c0,.19.07.13.26.35s.06.29.41.71l0,0a2.83,2.83,0,0,1,.2.28c.32.41.45.2.45,1.15h-.17a1.28,1.28,0,0,0-.88-1c0,.74.2.24.25.8-.19-.12-.08-.1-.32-.16,0,.41.07.14-.17.24.52.77,1.34,1.07,1.54,2.06.08.45.55.69.71,1.06.1.21,0,.05.13.26l.25.23a1.14,1.14,0,0,1,.27.7c.27,1.69,1.3,2,1.4,3.05l0,.6c-.06.35,0,.29.13.64s-.05.47-.12.74a1.61,1.61,0,0,1-.47-.07c0,.58,0,1.11.49,1.09.67,0,.91.83,2,.64a4.48,4.48,0,0,0,1.22-.15c.32-.19.35-.38.47-.51l0,0,.12-.13.07-.09.23-.14c.19,0,.48,0,.57-.28,0,0,0-.13,0-.15.12-.45.75-.44,1.16-.58l.92-.12h.19c.3,0-.08-.05.21-.05l.12,0,0,0c.28.13-.21.07.29.1.07-.17.17-.27.67-.25.34,0,.93.24,1.19-.84a.8.8,0,0,1,.16-.41c.2-.23.33-.13.64-.32,1.28-.74.78-.86,2.23-.89a4.14,4.14,0,0,0,1.53-.47c.94-.37.85-.64,2.31-.64a3.62,3.62,0,0,0,.92-.13c.35-.06,1.06.5,1.33.68.46-.12.21-.33.78,0,.34.2.57.13,1,.23.11.24,0,0,0,.39.26,0,.26-.1.49,0-.07.18-.16.12-.2.3l.16.46c.2.17.36,0,.56.24s.13.34.42.71a1.25,1.25,0,0,1,.26.77s0,0,0,0h0l0,0-.2.21c.48,0,.35.35.79.45a.59.59,0,0,1,.17,0s0,0,.16.07l-.06-.32c-.06-.24,0-.31.47-.87.3-.37.85-.37,1.07-.78a2,2,0,0,1,.36-.6c.2-.21.06.08.17-.22,0,.05,0,0,0,0l.07.09.13.19c-.24,0-.2,0-.32.16.17.36.18.31,0,.54a1.91,1.91,0,0,0-.4,1.25c0,.47-.11.37-.55.37-.07.29-.13.22-.17.56a1.68,1.68,0,0,0,.57-.17c.34-.08.37.19.56-.23l.32-1,.15.24s0,.05,0,.06l.06.11a.08.08,0,0,1,0,0c.45.91-.3.93-.34,1.46a2.7,2.7,0,0,0,.8-.15l0,0s0,0,0,0c.5.42,1,1,.8,1.7v0l0,.4a1.3,1.3,0,0,0,.34.5l.33.54c.25.27.61.15.89.47l.23.26c.23-.08.23-.18.48-.11l.18.07s0,0,.07,0c.21.06.1,0,.3.09s.82.46.89.64c.45,0,1.31-1.14,1.52-.32.4,0,.41-.28.73-.32l-.06.11c-.11.23-.06-.14-.11.29l.38.34.12.12.25.09a.72.72,0,0,1,.14.33.38.38,0,0,0,.23-.56c.94,0,1.22-.94,2.22-.91.64,0,1.15.23,1.62-.15l.17-.22c.12-.28,0-.35,0-.6l.43-1.16a1.59,1.59,0,0,1,.85-1c.23-.2.06-.05.08-.21v-.06l0-.21a1.63,1.63,0,0,1,.43-.76c.47-.39.27-.66,1-1.42l.46-.26.06,0,.16-.12Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M29.07,177.17Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M43.84,182.3a10,10,0,0,0-.82-.79,11.35,11.35,0,0,0-1.23-.81,2.75,2.75,0,0,0-.62-.24,1,1,0,0,0-.39,0,2.62,2.62,0,0,1,.66-.75,2.31,2.31,0,0,0,.88-1.19c.14-.46.28-.93.41-1.39l0,0-.61.38c-.39.22-.79.42-1.17.66a3.22,3.22,0,0,0-1,.94,1.37,1.37,0,0,0-.19,1c0,.24-.11.24-.11.24a1.74,1.74,0,0,0-.71.42c-.29.25-.58.49-.85.76a.75.75,0,0,0-.22.43,1.29,1.29,0,0,1-.33.72,3.89,3.89,0,0,0-.71,1.51c0,.2,0,.27.26.24a.58.58,0,0,0,.64.24s.07,0,.09,0c.42.21.61.17,1-.2a2.61,2.61,0,0,0,.27-.31c.19-.29.51-.31.8-.39a2.42,2.42,0,0,0,1-.4s.22-.18.32,0a2.36,2.36,0,0,1,.39.52,2.18,2.18,0,0,1,.19.76A4.9,4.9,0,0,0,42,186a1.57,1.57,0,0,0,1.83,1,3,3,0,0,1,1.58,0,2.58,2.58,0,0,1,.31.13l-.59,0a.16.16,0,0,0-.2.12c-.28.66-.55,1.33-.87,2-.21.42-.51.78-.76,1.18-.15.24-.36.51-.19.8a1.41,1.41,0,0,0,1.11.78l.81,0a1.27,1.27,0,0,0,.95-.7.46.46,0,0,0-.12-.45c-.08.21-.24.24-.41.26a.77.77,0,0,0-.27.11c0-.18.17-.17.32-.22l-.05-.35s-.08,0-.09.06c-.17.23-.26.26-.53.18l-.22-.07c-.24-.08-.28-.05-.3.18,0,0,0,.1,0,.18a.51.51,0,0,1,0-.63,13.71,13.71,0,0,1,.94-1.08,13.16,13.16,0,0,0,1.88-2.51,1.5,1.5,0,0,0,.17-.46.92.92,0,0,0-.43-1,8.72,8.72,0,0,0-1.14-.67.79.79,0,0,1-.49-.94l.1.3c.09.29.35.37.58.49s.74.36,1.1.57a1.1,1.1,0,0,1,.36,1.77c-.2.3-.39.62-.58.93-.07.11-.07.18.1.22.65.11,1.28.29,1.93.36a9.15,9.15,0,0,0,1.57,0,17.42,17.42,0,0,0,2.87-.6,4,4,0,0,1,1.69-.1l.12,0c0-.31-.07-.6-.1-.9s0-.5-.07-.75a6.21,6.21,0,0,0-.59-2.44l-.26-.39a1.63,1.63,0,0,1,.55.49,3,3,0,0,1,.45,1.22c.14.73.23,1.47.36,2.21a8.48,8.48,0,0,0,.66,2.31,4.2,4.2,0,0,0,1.51,1.72,24.7,24.7,0,0,0,2.26,1.23c.64.32,1.29.6,2,.86.82.33,1.65.63,2.48.94l1.19.43a.74.74,0,0,1,.48.46l-.65-.33,0,0c.06.23.14.46.19.69.12.62.23,1.25.34,1.87s.17,1,.23,1.46c0,.27,0,.54,0,.81a1.67,1.67,0,0,0,.38,1.13c.07.08.17.15.25.23a8.4,8.4,0,0,1,1.39,1.71,1.41,1.41,0,0,0,.49.45H69s0-.09,0-.11a.47.47,0,0,1,0-.62,1.36,1.36,0,0,0,.18-.43c.06-.26-.13-.45-.26-.64s-.1-.13-.15-.2l-.33.43,0,0a.76.76,0,0,0,.12-.86,1.37,1.37,0,0,0-.54-.73,1.31,1.31,0,0,1-.62-1.08c-.09-.55-.14-1.12-.2-1.68a5.45,5.45,0,0,1-.07-1c0-.48.1-1,.13-1.42a1,1,0,0,0-.29-.77,6.47,6.47,0,0,0-1.3-1c-.83-.57-1.66-1.14-2.44-1.76a11.41,11.41,0,0,1-2.68-3.07,3.76,3.76,0,0,1-.46-1.37,2.45,2.45,0,0,1,.15-1.14,4.84,4.84,0,0,0,.28,2c.42-.11.82-.27.88-.74a2.78,2.78,0,0,0-.06-.86c0-.26.1-.41.36-.36a1.4,1.4,0,0,1,.83.63c.66,1,1.28,2,1.92,3,.39.61.77,1.22,1.18,1.81.54.79,1.09,1.58,1.66,2.35a12.69,12.69,0,0,0,1,1.18c.31.34.65.66,1,1a11.71,11.71,0,0,0,2.15,1.63,12.43,12.43,0,0,0,3.08,1.35,19.68,19.68,0,0,0,2.28.49,10.27,10.27,0,0,0,1.92.12,13.9,13.9,0,0,0,2-.25,11.12,11.12,0,0,0,3-1c.47-.24.91-.54,1.35-.81,0,0,.08-.06.08-.09a2.91,2.91,0,0,0,0-.31c-.08,0-.18,0-.25,0a6.29,6.29,0,0,0-.71.3,13.94,13.94,0,0,1-2.58.93,13.46,13.46,0,0,1-1.79.34,14.53,14.53,0,0,1-2,0,8.43,8.43,0,0,1-3.4-1,10.36,10.36,0,0,1-2.29-1.6c-.25-.23-.51-.47-.76-.72a16.62,16.62,0,0,1-1.81-2.21,30.8,30.8,0,0,1-1.92-3.15c-.43-.79-.85-1.58-1.28-2.36a22.63,22.63,0,0,0-2.08-3.27,13.75,13.75,0,0,0-1.65-1.76,9.46,9.46,0,0,0-4.55-2.2,15.59,15.59,0,0,0-1.67-.23c-1-.05-1.93-.1-2.89-.07a15.93,15.93,0,0,0-4.12.57A11.46,11.46,0,0,0,47,181.62a5.61,5.61,0,0,1-1.62.72,2.12,2.12,0,0,1-.44,0,7.71,7.71,0,0,0-1,0Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M148.94,169.64h-.64v1.82h-.38v-1.82h-.65v-.38h1.67Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M151.31,169.26v2.2h-.38V169.9L150.2,171l-.72-1.13v1.56h-.38v-2.2h.41l.69,1.07.69-1.07Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M90.84,175v.71a5,5,0,0,0-1.25-.68,4.75,4.75,0,0,0-1.62-.26,4.91,4.91,0,0,0-1.9.36,4.59,4.59,0,0,0-1.5,1,4.52,4.52,0,0,0-1,1.49,4.67,4.67,0,0,0-.36,1.83,4.6,4.6,0,0,0,.36,1.81,4.32,4.32,0,0,0,1,1.49,4.43,4.43,0,0,0,1.5,1,4.74,4.74,0,0,0,1.9.37h.18a5.12,5.12,0,0,0,1.92-.36v-2.53h0a2.58,2.58,0,0,1-.88.56,2.7,2.7,0,0,1-1,.19,2.09,2.09,0,0,1-.43,0h0a2.4,2.4,0,0,1-.6-.15,2.48,2.48,0,0,1-.87-4.16,2.63,2.63,0,0,1,.87-.55,2.77,2.77,0,0,1,1-.19,2.65,2.65,0,0,1,1.91.74,2.41,2.41,0,0,1,.78,1.81v4.67h2.25V175Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M81.35,184.1l-5-4.8v4.8H74.14V171.46h2.24v4.78l5-4.76h3.18L78,177.77l6.56,6.33Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M98.92,174.75a4.07,4.07,0,0,1,1.66.33,3.76,3.76,0,0,1,1.28.9,4.06,4.06,0,0,1,.82,1.34A4.62,4.62,0,0,1,103,179v5.15h-2.24V179a1.88,1.88,0,0,0-.66-1.47,2.14,2.14,0,0,0-1.53-.6,2.17,2.17,0,0,0-1.55.6,2,2,0,0,0-.63,1.47v5.15H94.11V175h2.25v.67A4.57,4.57,0,0,1,97.5,175,3.74,3.74,0,0,1,98.92,174.75Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M129.31,175a3.93,3.93,0,0,1,1.5-.27v2.13a2.71,2.71,0,0,0-1.91.74,2.49,2.49,0,0,0-.78,1.81v4.69h-2.24V175h2.24v.69A4.59,4.59,0,0,1,129.31,175Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M135.88,174.75a5,5,0,0,1,3.5,1.36,4.85,4.85,0,0,1,1.05,1.49,4.35,4.35,0,0,1,.38,1.83,4.29,4.29,0,0,1-.38,1.81,4.63,4.63,0,0,1-1.05,1.49,5.16,5.16,0,0,1-5.42,1,4.84,4.84,0,0,1-1.57-1,4.66,4.66,0,0,1-1.06-1.49,4.45,4.45,0,0,1-.38-1.81,4.51,4.51,0,0,1,.38-1.83,4.89,4.89,0,0,1,1.06-1.49,5,5,0,0,1,1.57-1A5.12,5.12,0,0,1,135.88,174.75Zm0,2.13a2.64,2.64,0,0,0-1.9.74,2.39,2.39,0,0,0-.79,1.81,2.35,2.35,0,0,0,.79,1.79,2.21,2.21,0,0,0,.87.56,2.77,2.77,0,0,0,1,.19,2.73,2.73,0,0,0,1-.19,2.58,2.58,0,0,0,.88-.56,2.37,2.37,0,0,0,.78-1.79,2.41,2.41,0,0,0-.78-1.81A2.75,2.75,0,0,0,135.88,176.88Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M146.37,174.75a5.14,5.14,0,0,1,1.93.36,5,5,0,0,1,1.57,1,4.69,4.69,0,0,1,1,1.49,4.36,4.36,0,0,1,.39,1.83,4.3,4.3,0,0,1-.39,1.81,4.48,4.48,0,0,1-1,1.49,4.84,4.84,0,0,1-1.57,1,5.19,5.19,0,0,1-3.85,0,4.84,4.84,0,0,1-1.57-1,4.66,4.66,0,0,1-1.06-1.49,4.45,4.45,0,0,1-.38-1.81,4.51,4.51,0,0,1,.38-1.83,4.89,4.89,0,0,1,1.06-1.49,5,5,0,0,1,1.57-1A5.12,5.12,0,0,1,146.37,174.75Zm0,2.13a2.64,2.64,0,0,0-1.9.74,2.39,2.39,0,0,0-.79,1.81,2.61,2.61,0,0,0,1.66,2.35,2.77,2.77,0,0,0,1,.19,2.73,2.73,0,0,0,1-.19,2.58,2.58,0,0,0,.88-.56,2.37,2.37,0,0,0,.78-1.79,2.41,2.41,0,0,0-.78-1.81A2.73,2.73,0,0,0,146.37,176.88Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M122.4,175v.71a5.22,5.22,0,0,0-1.26-.68,4.75,4.75,0,0,0-1.62-.26,4.91,4.91,0,0,0-1.9.36,4.59,4.59,0,0,0-1.5,1,4.52,4.52,0,0,0-1,1.49,4.67,4.67,0,0,0-.36,1.83,4.6,4.6,0,0,0,.36,1.81,4.32,4.32,0,0,0,1,1.49,4.43,4.43,0,0,0,1.5,1,4.74,4.74,0,0,0,1.9.37h.18a5.08,5.08,0,0,0,1.92-.36v-2.53h0a2.49,2.49,0,0,1-.88.56,2.7,2.7,0,0,1-1,.19,2.09,2.09,0,0,1-.43,0h0a2.4,2.4,0,0,1-.6-.15,2.61,2.61,0,0,1-1.66-2.35,2.42,2.42,0,0,1,.79-1.81,2.63,2.63,0,0,1,.87-.55,2.77,2.77,0,0,1,1-.19,2.65,2.65,0,0,1,1.91.74,2.42,2.42,0,0,1,.79,1.81v4.67h2.24V175Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M111.53,175v.71a5.15,5.15,0,0,0-1.25-.68,4.27,4.27,0,0,0-.82-.2,5.83,5.83,0,0,0-1-.08,4.74,4.74,0,0,0-1.86.36,4.44,4.44,0,0,0-1.46,1,4.5,4.5,0,0,0-.94,1.49,5,5,0,0,0-.34,1.82h0a4.69,4.69,0,0,0,1.35,3.3,4.43,4.43,0,0,0,1.5,1,4.77,4.77,0,0,0,1.9.37H109a4.94,4.94,0,0,0,1.77-.35v-2.53h0a2.49,2.49,0,0,1-.88.56,2.68,2.68,0,0,1-1,.19,2.12,2.12,0,0,1-.44,0h0a2.64,2.64,0,0,1-.6-.15,2.59,2.59,0,0,1-1.65-2.36,2.42,2.42,0,0,1,.18-.94l0-.07a2.52,2.52,0,0,1,.57-.79,2.63,2.63,0,0,1,.87-.55,2.82,2.82,0,0,1,1-.19,2.64,2.64,0,0,1,1.9.74,2.52,2.52,0,0,1,.57.79l0,.07a2.3,2.3,0,0,1,.19,1V183a2.35,2.35,0,0,1-.79,1.79,2.72,2.72,0,0,1-3.25.41l-1.62,1.53a5.3,5.3,0,0,0,1.38.71,5.19,5.19,0,0,0,1.59.24,4.94,4.94,0,0,0,1.92-.37,5,5,0,0,0,1.57-1,4.66,4.66,0,0,0,1.06-1.49,4.45,4.45,0,0,0,.38-1.81v-8Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M76.75,191.81v.6H74.14V189h2.5v.6H74.81v.86h1.54v.58H74.81v.76Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M81.05,188.73v3.64h-.68v-.16a1.56,1.56,0,0,1-.76.2,1.36,1.36,0,0,1,0-2.71,1.59,1.59,0,0,1,.76.2v-1.17Zm-.68,2.85v-1.05a1,1,0,0,0-.64-.23.75.75,0,0,0-.78.76.73.73,0,0,0,.78.74A1,1,0,0,0,80.37,191.58Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M85.32,189.76v2.61h-.67v-.17a1.27,1.27,0,0,1-.71.21c-.77,0-1.12-.36-1.12-1.21v-1.44h.67v1.44c0,.41.2.61.57.61a.88.88,0,0,0,.59-.21v-1.84Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M89.44,191.88a1.22,1.22,0,0,1-1,.53,1.35,1.35,0,1,1,0-2.7,1.25,1.25,0,0,1,1,.52l-.43.4a.7.7,0,0,0-.59-.32.75.75,0,1,0,0,1.5.71.71,0,0,0,.59-.33Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M93.73,189.76v2.61h-.67v-.19a1.37,1.37,0,0,1-.76.23,1.36,1.36,0,0,1,0-2.71,1.53,1.53,0,0,1,.76.22v-.16Zm-.67.78a1,1,0,0,0-.64-.23.75.75,0,1,0,0,1.5,1,1,0,0,0,.64-.22Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M96.36,190.31v.92c0,.47.08.61.41.61a2.51,2.51,0,0,0,.31,0v.5a1.6,1.6,0,0,1-.61.1.76.76,0,0,1-.79-.82v-1.28h-.37v-.55h.37v-1h.68v1h.73v.55Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M98.69,189.12a.39.39,0,1,1,.77,0,.39.39,0,1,1-.77,0Zm0,.67h.67v2.62h-.67Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M104,191.06a1.43,1.43,0,1,1-1.43-1.35A1.39,1.39,0,0,1,104,191.06Zm-.66,0a.77.77,0,1,0-.77.75A.76.76,0,0,0,103.31,191.06Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M108.14,191v1.46h-.67V191c0-.4-.2-.6-.57-.6a.85.85,0,0,0-.58.2v1.86h-.67v-2.62h.67V190a1.16,1.16,0,0,1,.7-.21C107.79,189.75,108.14,190.1,108.14,191Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M113.39,189.61v1.21H115v.6h-1.62v1h-.67V189h2.56v.6Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M119.6,191.06a1.43,1.43,0,1,1-1.43-1.35A1.39,1.39,0,0,1,119.6,191.06Zm-.66,0a.77.77,0,1,0-.77.75A.76.76,0,0,0,118.94,191.06Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M123.76,189.76v2.61h-.67v-.17a1.29,1.29,0,0,1-.71.21c-.77,0-1.12-.36-1.12-1.21v-1.44h.67v1.44c0,.41.2.61.57.61a.9.9,0,0,0,.59-.21v-1.84Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M128.05,191v1.46h-.67V191c0-.4-.19-.6-.56-.6a.85.85,0,0,0-.58.2v1.86h-.67v-2.62h.67V190a1.16,1.16,0,0,1,.7-.21C127.7,189.75,128.05,190.1,128.05,191Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M132.47,188.73v3.64h-.67v-.16a1.59,1.59,0,0,1-.76.2,1.36,1.36,0,0,1,0-2.71,1.59,1.59,0,0,1,.76.2v-1.17Zm-.67,2.85v-1.05a1,1,0,0,0-.64-.23.75.75,0,0,0-.78.76.73.73,0,0,0,.78.74A1,1,0,0,0,131.8,191.58Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M136.9,189.76v2.61h-.67v-.19a1.37,1.37,0,0,1-.76.23,1.36,1.36,0,0,1,0-2.71,1.53,1.53,0,0,1,.76.22v-.16Zm-.67.78a1,1,0,0,0-.64-.23.75.75,0,1,0,0,1.5,1,1,0,0,0,.64-.22Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M139.53,190.31v.92c0,.47.08.61.41.61a2.51,2.51,0,0,0,.31,0v.5a1.6,1.6,0,0,1-.61.1.76.76,0,0,1-.79-.82v-1.28h-.37v-.55h.37v-1h.68v1h.73v.55Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M141.86,189.12a.39.39,0,0,1,.38-.4.38.38,0,0,1,.38.4.38.38,0,0,1-.38.39A.38.38,0,0,1,141.86,189.12Zm0,.67h.67v2.62h-.67Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M147.14,191.06a1.43,1.43,0,1,1-1.43-1.35A1.39,1.39,0,0,1,147.14,191.06Zm-.66,0a.77.77,0,1,0-.77.75A.77.77,0,0,0,146.48,191.06Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M151.31,191v1.46h-.67V191c0-.4-.2-.6-.57-.6a.85.85,0,0,0-.58.2v1.86h-.67v-2.62h.67V190a1.16,1.16,0,0,1,.7-.21C151,189.75,151.31,190.1,151.31,191Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 0.13,
    x2: 567.05,
    y2: 0.13
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.12,
    y1: 378.08,
    x2: 567.05,
    y2: 378.08
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 0.13,
    x2: 0.13,
    y2: 378.08
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 378.08,
    y1: 0.13,
    x2: 378.08,
    y2: 378.08
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 37.92,
    y1: 0.13,
    x2: 37.92,
    y2: 378.08
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 75.72,
    y1: 0.13,
    x2: 75.72,
    y2: 378.08
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 113.51,
    y1: 0.13,
    x2: 113.51,
    y2: 378.08
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 151.31,
    y1: 0.13,
    x2: 151.31,
    y2: 378.08
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 189.1,
    y1: 0.13,
    x2: 189.1,
    y2: 378.08
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 226.9,
    y1: 0.13,
    x2: 226.9,
    y2: 378.08
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 264.69,
    y1: 0.13,
    x2: 264.69,
    y2: 378.08
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 302.49,
    y1: 0.13,
    x2: 302.49,
    y2: 378.08
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 340.28,
    y1: 0.13,
    x2: 340.28,
    y2: 378.08
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 19.02,
    y1: 0.13,
    x2: 19.02,
    y2: 378.08
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 56.82,
    y1: 0.13,
    x2: 56.82,
    y2: 378.08
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 94.61,
    y1: 0.13,
    x2: 94.61,
    y2: 378.08
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 132.41,
    y1: 0.13,
    x2: 132.41,
    y2: 378.08
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 170.2,
    y1: 0.13,
    x2: 170.2,
    y2: 378.08
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 208,
    y1: 0.13,
    x2: 208,
    y2: 378.08
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 245.79,
    y1: 0.13,
    x2: 245.79,
    y2: 378.08
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 283.59,
    y1: 0.13,
    x2: 283.59,
    y2: 378.08
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 321.38,
    y1: 0.13,
    x2: 321.38,
    y2: 378.08
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 359.18,
    y1: 0.13,
    x2: 359.18,
    y2: 378.08
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.12,
    y1: 340.28,
    x2: 567.05,
    y2: 340.28
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.12,
    y1: 302.49,
    x2: 567.05,
    y2: 302.49
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.12,
    y1: 264.69,
    x2: 567.05,
    y2: 264.69
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.12,
    y1: 226.9,
    x2: 567.05,
    y2: 226.9
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 189.1,
    x2: 567.05,
    y2: 189.1
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 151.31,
    x2: 567.05,
    y2: 151.31
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 113.51,
    x2: 567.05,
    y2: 113.51
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 75.72,
    x2: 567.05,
    y2: 75.72
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 37.92,
    x2: 567.05,
    y2: 37.92
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.12,
    y1: 359.18,
    x2: 567.05,
    y2: 359.18
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.12,
    y1: 321.38,
    x2: 567.05,
    y2: 321.38
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.12,
    y1: 283.59,
    x2: 567.05,
    y2: 283.59
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.12,
    y1: 245.79,
    x2: 567.05,
    y2: 245.79
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.12,
    y1: 208,
    x2: 567.05,
    y2: 208
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 170.2,
    x2: 567.05,
    y2: 170.2
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 132.41,
    x2: 567.05,
    y2: 132.41
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 94.61,
    x2: 567.05,
    y2: 94.61
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 56.82,
    x2: 567.05,
    y2: 56.82
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 19.02,
    x2: 567.05,
    y2: 19.02
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 415.87,
    y1: 0.13,
    x2: 415.87,
    y2: 378.08
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 453.67,
    y1: 0.13,
    x2: 453.67,
    y2: 378.08
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 491.46,
    y1: 0.13,
    x2: 491.46,
    y2: 378.08
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 529.26,
    y1: 0.13,
    x2: 529.26,
    y2: 378.08
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 567.05,
    y1: 0.13,
    x2: 567.05,
    y2: 378.08
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 396.98,
    y1: 0.13,
    x2: 396.98,
    y2: 378.08
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 434.77,
    y1: 0.13,
    x2: 434.77,
    y2: 378.08
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 472.57,
    y1: 0.13,
    x2: 472.57,
    y2: 378.08
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 510.36,
    y1: 0.13,
    x2: 510.36,
    y2: 378.08
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 548.16,
    y1: 0.13,
    x2: 548.16,
    y2: 378.08
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 0.13,
    y: 0.13,
    width: 566.93,
    height: 377.95
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideMaterial6);
export default __webpack_public_path__ + "static/media/guideMaterial6.dff681859d0dec0a64ecd4ff109dac33.svg";
export { ForwardRef as ReactComponent };